module.exports = __webpack_public_path__ + "img/snow.213ef762.svg";